export default {"src":"/_next/static/media/newsletter-vae.abfb2292.webp","height":500,"width":628,"blurWidth":0,"blurHeight":0};